import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Select,
  Divider,
  Autocomplete,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function BatchCollection(props) {
  const searchParams = new URLSearchParams(window.location.search);
  const collectionId = searchParams.get("collection_id");
  const [loading, setLoading] = useState(true);
  const [collectionsData, setCollectionsData] = useState([]);
  const [batchAction, setBatchAction] = useState("");
  const [batchCollectionName, setBatchCollectionName] = useState("");
  const [batchPromotionalName, setBatchPromotionalName] = useState("");
  const [batchCreatedBy, setBatchCreatedBy] = useState(null);
  const [batchUpdatedBy, setBatchUpdatedBy] = useState(null);
  const [batchMarketingKeywords, setBatchMarketingKeywords] = useState("");
  const [selectedCollections, setSelectedCollections] = useState([]);

  const resetBatchForm = () => {
    setBatchAction("");
    setBatchCollectionName("");
    setBatchPromotionalName("");
    setBatchCreatedBy(null);
    setBatchUpdatedBy(null);
    setBatchMarketingKeywords("");
    setSelectedCollections([]);
    // Optionally, you can clear selectedRows in parent via a prop callback if needed
    // if (props.onClearSelectedRows) props.onClearSelectedRows();
  };

  const handleBatchSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (batchAction === "Merge") {
      // Step 1: Create the merged collection
      if (
        !batchCollectionName ||
        !batchPromotionalName ||
        !batchMarketingKeywords
      ) {
        alert(
          "Please provide a name, promotional name, and marketing keywords for the merged collection."
        );
        setLoading(false);
        return;
      }
      // Step 2: Extract tag IDs from a row/collection
      const extractTagIds = (item) => {
        if (!item) return [];
        if (Array.isArray(item.tag)) {
          return item.tag.map((t) =>
            typeof t === "object" && t.id ? t.id : t
          );
        }
        if (Array.isArray(item.tags)) {
          return item.tags.map((t) =>
            typeof t === "object" && t.id ? t.id : t
          );
        }
        if (Array.isArray(item.tag_ids)) {
          return item.tag_ids;
        }
        if (item.tag_id) {
          return [item.tag_id];
        }
        return [];
      };

      // Step 3: Filter out any undefined/null items before flatMap
      const rowTagIds = props.selectedRows.filter(Boolean).flatMap(extractTagIds);
      const collectionTagIds = selectedCollections.filter(Boolean).flatMap(extractTagIds);
      const mergedTagIds = [...new Set([...rowTagIds, ...collectionTagIds])];

      const reqData = {
        'collection_name': batchCollectionName,
        'promotional_name': batchPromotionalName,
        'marketing_keyword': batchMarketingKeywords,
        'search_collection': mergedTagIds, // array of tag IDs
        'collection_status': "live",
        'created_by': batchCreatedBy ? batchCreatedBy : "",
        'updated_by': batchUpdatedBy ? batchUpdatedBy : "",
      };

      try {
        // Create the new merged collection
        const resData = await postData(
          "/api/product/product-collection",
          reqData
        );
        if (resData["data"]["code"] === "200") {
          // Step 2: Set selected rows and collections to delete
          const newCollectionId = resData["data"]["collection_id"] || resData["data"]["id"];
          if (newCollectionId) {
            // Create collection_url and update the new collection
            const collectionUrl = `https://acc.bizallen.com/products?collection_id=${newCollectionId}`;
            await postData("/api/product/product-collection", {
              'collection_id': newCollectionId,
              'collection_url': collectionUrl,
            });
          }
          /* const allToDelete = [
            ...props.selectedRows.map((row) => row.id).filter(Boolean),
            ...selectedCollections.map((item) => item.id).filter(Boolean),
          ];
          for (const id of allToDelete) {
            const deleteReq = {
              'collection_id': id,
              'collection_status': "delete",
            };
            await postData("/api/product/product-collection", deleteReq);
          } */
          setLoading(false);
          alert("Batch merged successfully");
          if (props.onBatchUpdate) props.onBatchUpdate(); 
          resetBatchForm(); // <-- Reset form after success
        } else {
          alert("Batch merge failed");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }

    } else if (batchAction === "Delete") {
      // Set selected rows and collections to delete
      const allToDelete = [
        ...props.selectedRows.map((row) => row.id).filter(Boolean),
        ...selectedCollections.map((item) => item.id).filter(Boolean),
      ];
      if (allToDelete.length === 0) {
        alert("Please select at least one collection to delete.");
        setLoading(false);
        return; // Stop if validation fails
      }
      try {
        for (const id of allToDelete) {
          const deleteReq = {
            'collection_id': id,
            'collection_status': "delete",
          };
          await postData("/api/product/product-collection", deleteReq);
        }
        setLoading(false);
        alert("Collections deleted successfully");
        if (props.onBatchUpdate) props.onBatchUpdate(); 
        resetBatchForm(); // <-- Reset form after success
      } catch (error) {
        console.error("Error submitting delete request:", error);
        setLoading(false);
      }
      
    } else if (batchAction === "Archived") {
      // Set selected rows and collections to archived
      const allToArchive = [
        ...props.selectedRows.map((row) => row.id).filter(Boolean),
        ...selectedCollections.map((item) => item.id).filter(Boolean),
      ];
      if (allToArchive.length === 0) {
        alert("Please select at least one collection to archive.");
        setLoading(false);
        return;
      }
      try {
        for (const id of allToArchive) {
          const archiveReq = {
            collection_id: id,
            collection_status: "archived",
          };
          await postData("/api/product/product-collection", archiveReq);
        }
        setLoading(false);
        alert("Collections archived successfully");
        if (props.onBatchUpdate) props.onBatchUpdate(); 
        resetBatchForm(); // <-- Reset form after success
      } catch (error) {
        console.error("Error submitting archive request:", error);
        setLoading(false);
      }
    } else {
      alert("Please select a valid batch action.");
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        let resData = await getData("/api/product/product-collection");
        let live_collections = resData["data"]["live_collections"];
        if (collectionId) {
          console.log(collectionId);
          const filteredCollections = live_collections.filter(
            (collection) => collection.id === collectionId
          );
          setCollectionsData(filteredCollections);
        } else {
          setCollectionsData(live_collections);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleBatchActionChange = (event) => {
    setBatchAction(event.target.value);
  };

  // Utility to merge and deduplicate selected collections by id
  const getUniqueSelectedCollections = () => {
    const all = [...(props.selectedRows || []), ...(selectedCollections || [])];
    const seen = new Set();
    return all.filter((item) => {
      if (!item || !item.id) return false;
      if (seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    });
  };

  // Determine if more than 1 entry is selected for batch action
  const selectedCount = (props.selectedRows?.length || 0) + (props.selectedCollections?.length || 0);
  const shouldShowAccordion = selectedCount > 1;

  return (
    <Box sx={{ width: "100%", mt: 2, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Accordion
            expanded={shouldShowAccordion && props.expanded}
            onChange={(_, expanded) => props.setExpanded(expanded)}
            selectedRows={props.selectedRows}
            sx={{
              backgroundColor: "#F8F9FA",
              mt: 2,
              borderRadius: 0,
              boxShadow: 0,
              display: shouldShowAccordion ? 'block' : 'none',
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                p: { xs: 2, sm: 4 },
                pt: 0,
                pb: 0,
                gap: { xs: 1, sm: 2 },
                height: { xs: 48, sm: 58 },
                alignItems: "center",
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontFamily: "Inter", fontWeight: "700", fontSize: 16 }}
              >
                Create batch actions of Collection
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                p: 4,
                pt: 2,
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Grid
                container
                spacing={2}
                sx={{
                  mb: 3,
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                {/* Label and Search Box */}
                {/* <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontFamily: "Inter", fontWeight: 700, fontSize: 14 }}
                  >
                    Similar collections
                  </Typography>
                  <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={Array.isArray(collectionsData) ? collectionsData : []}
                    getOptionLabel={(option) => option.collection}
                    filterSelectedOptions
                    value={selectedCollections} // Bind the state to the Autocomplete
                    onChange={(event, newValue) =>
                      setSelectedCollections(newValue)
                    }
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Box
                          key={option.id}
                          component="span"
                          {...getTagProps({ index })}
                        >
                          {option.collection}
                        </Box>
                      ))
                    }
                    renderInput={(params) => {
                      // Hide placeholder if input is not empty or tags are selected
                      const inputValue =
                        params.inputProps && params.inputProps.value
                          ? params.inputProps.value
                          : "";
                      const showPlaceholder =
                        !inputValue && selectedCollections.length === 0;
                      return (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={
                            showPlaceholder
                              ? "Search by item, name, tag, product code"
                              : ""
                          }
                        />
                      );
                    }}
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '0px',
                        backgroundColor: '#fff',
                        minHeight: '35px',
                        // Remove fixed height to allow wrapping
                        height: 'auto',
                        alignItems: 'flex-start',
                        flexWrap: 'wrap',
                        '& .MuiAutocomplete-tag': {
                          marginBottom: '4px',
                        },
                        '&.Mui-focused': {
                          minHeight: '35px',
                        },
                      },
                    }}
                  />
                </Grid> */}
                {/* Filters pushed to the right */}
                {/* <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' }, gap: 2, width: '100%' }}>
                  <Select size="small" sx={{ width: "150px", height: "35px", borderRadius: "0px", backgroundColor: '#fff' }}>
                    <MenuItem value="Tag1">Tag1</MenuItem>
                    <MenuItem value="Tag2">Tag2</MenuItem>
                    <MenuItem value="Tag3">Tag3</MenuItem>
                  </Select>
                  <Select size="small" sx={{ width: "150px", height: "35px", borderRadius: "0px", backgroundColor: '#fff' }}>
                    <MenuItem value="TagA">TagA</MenuItem>
                    <MenuItem value="TagB">TagB</MenuItem>
                    <MenuItem value="TagC">TagC</MenuItem>
                  </Select>
                </Grid> */}
              </Grid>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 700,
                  fontSize: 14,
                  mb: 1,
                }}
              >
                Collection list | selected{" "}
                {getUniqueSelectedCollections().length}
              </Typography>
              <Divider />
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 2,
                  mb: 5,
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Grid item xs={12} md={3}>
                  <FormGroup column sx={{ display: "flex-row" }}>
                    {getUniqueSelectedCollections().map((collection, index) =>
                      collection && collection.collection ? (
                        <Box
                          key={collection.id}
                          sx={{ display: "flex", alignItems: "center", mt: 1 }}
                        >
                          <Checkbox
                            checked={true}
                            onChange={() => {
                              // Remove from selectedCollections if present, otherwise call onToggleRow
                              if (selectedCollections.find((item) => item.id === collection.id)) {
                                setSelectedCollections((prev) => prev.filter((item) => item.id !== collection.id));
                              } else if (props.onToggleRow) {
                                props.onToggleRow(collection.collection);
                              }
                            }}
                            sx={{
                              padding: 0,
                              marginRight: 1,
                              '&.Mui-checked': {
                                color: '#565E6D',
                              },
                              '& .MuiSvgIcon-root': {
                                borderRadius: '4px',
                              },                              
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              fontFamily: "Inter",
                              fontWeight: 700,
                              fontSize: 14,
                              mt: 0,
                            }}
                          >
                            {collection.collection} &nbsp;&nbsp;
                          </Typography>
                        </Box>
                      ) : null
                    )}
                  </FormGroup>
                </Grid>
                {/* Batch Action */}
                <Grid item xs={12} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Batch Action{" "}
                  </Typography>
                  <Select
                    size="small"
                    value={batchAction}
                    onChange={handleBatchActionChange}
                    sx={{
                      width: { xs: "100%", md: "193px" },
                      height: "35px",
                      borderRadius: "0px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <MenuItem value="Merge">Merge</MenuItem>
                    <MenuItem value="Delete">Delete</MenuItem>
                    <MenuItem value="Archived">Archived</MenuItem>
                    {/* <MenuItem value="Remove assigned">Remove assigned</MenuItem> */}
                  </Select>
                </Grid>
              </Grid>
              <Divider sx={{ mb: 3 }} />

              {/* New Content */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 2, md: 16 },
                  mb: 5,
                  width: "100%",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Name of the collection
                  </Typography>
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      },
                    }}
                    variant="outlined"
                    value={batchCollectionName}
                    onChange={(e) => setBatchCollectionName(e.target.value)}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Create Promotional Name
                  </Typography>
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      },
                    }}
                    variant="outlined"
                    value={batchPromotionalName}
                    onChange={(e) => setBatchPromotionalName(e.target.value)}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Add marketing keywords
                  </Typography>
                  <TextField
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      },
                    }}
                    variant="outlined"
                    helperText="Summer, Essentials, light, breezy..."
                    value={batchMarketingKeywords}
                    onChange={(e) => setBatchMarketingKeywords(e.target.value)}
                  />
                </Box>
              </Box>

              {/* Save Button */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                  width: "100%",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    width: "307px",
                    height: "44px",
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                  onClick={handleBatchSubmit}
                >
                  Save
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>
    </Box>
  );
}
